import { fromJS, Record } from 'immutable';
import {
  generateKeys,
  generateSchema,
} from '../../../utils/helpers/model.helper';

export const LINKED_DOCUMENT_REFERENCE_SCHEMA = Object.freeze({
  ID: '',
  REVISION_ID: '',
  REFERENCE_LOCAL_ID: '',
  TYPE: '', // documentType as string,
  ADDED_DATE: null, // i2g-date-time (yyyy-mm-dd'T'hh:mm:ssZ)
  UPDATED_DATE: null, // i2g-date-time (yyyy-mm-dd'T'hh:mm:ssZ)
});
export const RECORD = generateSchema(LINKED_DOCUMENT_REFERENCE_SCHEMA);
export const KEYS: any = generateKeys(LINKED_DOCUMENT_REFERENCE_SCHEMA);

export class LinkedDocumentReference extends Record(RECORD) {
  static KEYS: any = KEYS;

  constructor(props?: any) {
    super(props && props.toMap ? props.toMap() : fromJS(props || {}));
  }

  get id(): string {
    return this.get(KEYS.ID);
  }

  get revisionId(): string {
    return this.get(KEYS.REVISION_ID);
  }

  get referenceLocalId(): string {
    return this.get(KEYS.REFERENCE_LOCAL_ID);
  }

  get type(): string {
    return this.get(KEYS.TYPE);
  }

  get addedDate(): string {
    return this.get(KEYS.ADDED_DATE);
  }

  get updatedDate(): string {
    return this.get(KEYS.UPDATED_DATE);
  }
}
